import React from 'react';
import { Modal, View } from 'react-native';
import { translate } from '../../../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import CustomButton from '../../../components/CustomButton';
import { crmService } from '../../../services/central-api/crm';

interface ModalProps {
    cameraId: string;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ForceSynchronizationModal({ cameraId, isModalVisible, setIsModalVisible }: ModalProps) {
    const { styles } = useStyles(styleSheet);

    async function handleConfirm() {
        try {
            await crmService.syncCameraConfiguration(cameraId);
        } finally {
            setIsModalVisible(false);
        }
    }

    return (
        <Modal transparent={true} visible={isModalVisible} animationType='fade' onRequestClose={() => setIsModalVisible(false)}>
            <View style={styles.container}>
                <View style={styles.formContainer}>
                    <MyAppText style={styles.title}>{translate('forceSynchronization')}</MyAppText>
                    <MyAppText style={styles.description}>{translate('forceSynchronizationDescription')}</MyAppText>
                    <View style={styles.buttonsRow}>
                        <CustomButton
                            text={translate('cancel')}
                            type='secondary'
                            onPress={() => setIsModalVisible(false)}
                        />
                        <CustomButton
                            text={translate('conclude')}
                            type='primary'
                            onPress={handleConfirm}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        width: '25%',
        backgroundColor: theme.colors.card.background,
        borderRadius: 4,
        padding: 25,
        rowGap: 20,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    description: {
        fontSize: 14,
    },
    buttonsRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 20,
    }
}));
